const upsertParamsToQueryKey = <P = any>(queryKey: string[], newParams: P) => {
  const [endpoint, oldParams = {}] = queryKey

  return [endpoint, { ...oldParams, ...newParams }]
}

export default upsertParamsToQueryKey
